export default {
  purple: '#A3A2FF',
  blue: '#003862',
  gray: '#f5f5f5',
  red: '#E2173D',
}